/* eslint-disable lines-between-class-members,dot-notation */
import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { Property } from "./Property";
import { propertyFilters, propertyFilterTypes } from "./enums";
import { PropertyGroup } from "./PropertyGroup";
/**
 * PropertyType class
 */

export class PropertyType extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getId = () => {
      return this.model.id;
    };

    this.getGroupId = () => {
      return this.model.groupId;
    };

    this.getFilterType = (asLabel = false) => {
      return asLabel ? PropertyType.propertyFilters[this.model.filterType || 'unknown'] || PropertyType.propertyFilters['unknown'] : this.model.filterType;
    };

    this.getName = () => {
      return this.model.name;
    };

    this.getMeasure = () => {
      return this.model.measure;
    };

    this.getAlias = () => {
      return this.model.alias;
    };

    this.getDescription = () => {
      return this.model.description;
    };

    this.getAttributeHint = () => {
      return this.model.attributeHint;
    };

    this.getSort = () => {
      return this.model.sort;
    };

    this.getIsFilter = () => {
      return this.model.isFilter;
    };

    this.getIsOption = () => {
      return this.model.isOption;
    };

    this.getIsAdditional = () => {
      return this.model.isAdditional;
    };

    this.getIsDynamic = () => {
      return this.model.isDynamic;
    };

    this.getNameAndMeasure = () => {
      return this.model.nameAndMeasure;
    };

    this.getProperty = property => {
      return this.getRelation('property', Property, property);
    };

    this.getGroup = group => {
      return this.getRelation('group', PropertyGroup, group);
    };
  }

  /**
   * Create propertyType
   *
   * @param {object} object
   *
   * @return {PropertyType}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Create list propertyTypes
   *
   * @param {object} objects
   *
   * @return {Array.<PropertyType>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map propertyTypes
   *
   * @param {Array.<object>} objects
   * @param {function(PropertyType): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get propertyType id
   *
   * @return {number}
   */


}
PropertyType.propertyFilterTypes = propertyFilterTypes;
PropertyType.propertyFilters = propertyFilters;